import React, { useContext, useEffect, useState } from "react";
import "./Perfect_Partner.css";
import Gift_Card from "../../common_components/gift_card/Gift_Card";
import Common_Title from "../../common_components/common_title/Common_Title";
import { Context } from "../../../utils/context";
import {
  Products,
  ProductsBestSelling,
} from "../../../utils/luxuryapis/Product/Product";
import { encodeId } from "../../../utils/common";

const Perfect_Partner = () => {
  const gifts1 = [
    {
      img: "/assest/luxury_images/gifts/img1.png",
      name: "ODA Lapel Pin (Nickel)",
    },
    {
      img: "/assest/luxury_images/gifts/img2.png",
      name: "ODA Lapel Pin (Nickel)",
    },
    {
      img: "/assest/luxury_images/gifts/img3.png",
      name: "ODA Lapel Pin (Nickel)",
    },
    {
      img: "/assest/luxury_images/gifts/img4.png",
      name: "ODA Lapel Pin (Nickel)",
    },

    {
      img: "/assest/luxury_images/gifts/img1.png",
      name: "ODA Lapel Pin (Nickel)",
    },
    {
      img: "/assest/luxury_images/gifts/img2.png",
      name: "ODA Lapel Pin (Nickel)",
    },
    {
      img: "/assest/luxury_images/gifts/img3.png",
      name: "ODA Lapel Pin (Nickel)",
    },
    {
      img: "/assest/luxury_images/gifts/img4.png",
      name: "ODA Lapel Pin (Nickel)",
    },
  ];

  const { IMG_URL } = useContext(Context);
  const [productdata, setproductData] = useState();
  const getAllData = async () => {
    let res;

    res = await Products({ partnership: true });

    if (res?.success) {
      setproductData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  const [CustomerFavorite, setCustomerFavorite] = useState();
  const getAllCustomerFavorite = async () => {
    let res;

    res = await ProductsBestSelling({});

    if (res?.success) {
      setCustomerFavorite(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllData();
    getAllCustomerFavorite();
  }, []);
  return (
    <section className="Perfect_Partner">
      {productdata?.data && (
        <div className="div1">
          <p className="common_section_title">The Perfect Partner</p>

          <div className="row justify-content-center ">
            {productdata?.data?.map((item, index) => {
              return (
                <div className="col-xl-2 col-lg-3 col-md-3 col-6" key={index}>
                  <Gift_Card
                    imgSrc={IMG_URL + item?.image1}
                    productName={item?.name}
                    path={`/luxury/product-details/${encodeId(item?.id)}`}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}

      {CustomerFavorite?.data?.length > 0 && (
        <div className="div1">
          <p className="common_section_title">Customers Favorite</p>

          <div className="row justify-content-center ">
            {CustomerFavorite?.data?.map((item, index) => {
              return (
                <div className=" col-xl-2 col-lg-3 col-md-3 col-6" key={index}>
                  <Gift_Card
                    imgSrc={IMG_URL + item?.image1}
                    productName={item?.name}
                    path={`/luxury/product-details/${encodeId(item?.id)}`}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </section>
  );
};

export default Perfect_Partner;
